export {default} from './CoachReportPopover.connect';
